import {RouteDefinition} from "../../../routes"
import {ScreenCleanerScreen} from "./ScreenCleanerScreen"
export const ScreenCleanerRoutes: RouteDefinition[] = [
    {
        routerLink: "/settings/screen-cleaner",
        component: ScreenCleanerScreen
    }
]
